'use strict';

var _ = require('lodash');
var DataRetrievalCacheService = function DataRetrievalCacheService($cacheFactory) {
  var dataRetrievalCache = $cacheFactory('dataRetrievalService');
  var cachedUrls = [];
  var CACHED_DATA_QUANTITY = 10;
  function addUrlToList(url) {
    var index = cachedUrls.indexOf(url);
    if (index !== -1) {
      cachedUrls.splice(index, 1);
    }
    cachedUrls.push(url);
  }
  function putDataToCache(url, data, cacheRawData, etag) {
    addUrlToList(url);
    dataRetrievalCache.put(url, {
      data: data,
      rowCached: cacheRawData,
      etag: etag
    });
  }
  function invalidateRawCache() {
    var removedRecords = [];
    _.forEach(cachedUrls, function (url) {
      var record = dataRetrievalCache.get(url);
      if (!record.etag) {
        dataRetrievalCache.remove(url);
        removedRecords.push(url);
      } else {
        record.rowCached = false;
      }
    });
    cachedUrls = _.xor(cachedUrls, removedRecords);
    if (cachedUrls.length > CACHED_DATA_QUANTITY) {
      var extraCachedUrl = cachedUrls.splice(0, cachedUrls.length - CACHED_DATA_QUANTITY);
      _.forEach(extraCachedUrl, dataRetrievalCache.remove);
    }
  }
  function hasRawDataCache(url) {
    var cachedData = dataRetrievalCache.get(url);
    return cachedData !== undefined && cachedData.rowCached;
  }
  function getData(url) {
    var cachedData = dataRetrievalCache.get(url);
    return cachedData ? cachedData.data : null;
  }
  function getEtag(url) {
    var cachedData = dataRetrievalCache.get(url);
    return cachedData && cachedData.etag ? cachedData.etag : '';
  }
  return {
    putData: putDataToCache,
    invalidateRawCache: invalidateRawCache,
    hasRawDataCache: hasRawDataCache,
    getData: getData,
    getEtag: getEtag
  };
};
DataRetrievalCacheService.$inject = ['$cacheFactory'];
module.exports = DataRetrievalCacheService;